import { useEffect, useState } from 'react';

const NO_URLS: readonly string[] = [];

// URLs are made in the effect (not during render) so StrictMode's re-run never revokes live ones.
export function useObjectUrls(items: readonly { blob: Blob }[]): readonly string[] {
    const [urls, setUrls] = useState<readonly string[]>(NO_URLS);

    useEffect(() => {
        const created = items.map((item) => URL.createObjectURL(item.blob));
        setUrls(created);
        return () => created.forEach((url) => URL.revokeObjectURL(url));
    }, [items]);

    return urls;
}
